import { PageVisibilityFunctions } from '../types';
import withdrawDeclaration from '../WithdrawForm/withdrawDeclaration';
import withdrawReason from '../WithdrawForm/withdrawReason';

export const Withdraw: PageVisibilityFunctions = {
    withdrawDeclaration,
    withdrawReason,
};
